import { isString } from 'lodash';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router';

import { useEvent } from '@legacy-providers/event';

import { Select } from '@shared/ui/components/Select';

import { searchRegistrationOrUserOptions } from './searchRegistrationOrUserOptions';

export function GlobalSearch() {
  const event = useEvent();
  const history = useHistory();

  const [selectedResult, setSelectedResult] = useState<string | number | null>();

  useEffect(() => {
    if (isString(selectedResult)) {
      history.push(selectedResult);
      setSelectedResult(null);
    }
  }, [selectedResult]);

  return (
    <Select
      value={selectedResult}
      onChange={setSelectedResult}
      options={(query) => searchRegistrationOrUserOptions(event.id, query)}
      placeholder="Go to registration or user…"
      caret={false}
      searchOnFocus={false}
      noResultsLabel="No results"
      className="h-full"
    />
  );
}
